import { IEditCommand } from "./IEditCommand";

export abstract class AbstractEditCommand<TSource, TState> implements IEditCommand<TSource> {
  private _isDone: boolean;
  private _backupped: TState;

  protected abstract backup(source: TSource): TState;
  protected abstract execute(source: TSource): void;
  protected abstract revert(source: TSource, backupped: TState): void;

  do(source: TSource): void {
    this._backupped = this.backup(source);
    this.execute(source);
    this._isDone = true;
  }

  undo(source: TSource): void {
    if (!this._isDone) {
      return;
    }
    this.revert(source, this._backupped);
  }
}
